import { BrowserRouter } from "react-router-dom";
import { Suspense } from "react";
import { Toaster } from "react-hot-toast";
import { AppRoutes } from "./router/index";
import { CartProvider } from "./contexts/CartContext";
import { AuthProvider } from "./contexts/AuthContext";
import { VatProvider } from "./contexts/VatContext";
import MiniCart from "./components/feature/MiniCart";
import BackToTop from "./components/feature/BackToTop";
import LeadCaptureModal from "./components/feature/LeadCaptureModal";

function App() {
    return (
        <AuthProvider>
            <VatProvider>
                <CartProvider>
                    <BrowserRouter basename={"/"}>
                        <div className="App">
                            <Suspense
                                fallback={
                                    <div className="flex items-center justify-center min-h-screen">
                                        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
                                    </div>
                                }
                            >
                                <AppRoutes />
                            </Suspense>
                            <MiniCart />
                            <BackToTop />
                            <LeadCaptureModal />
                            <Toaster
                                position="top-right"
                                toastOptions={{
                                    duration: 3000,
                                    style: {
                                        background: "#FEFEFE",
                                        color: "#1E2328",
                                        border: "1px solid #E8ECF2",
                                        padding: "16px",
                                        borderRadius: "8px",
                                        fontFamily: "Inter, sans-serif",
                                    },
                                    success: {
                                        iconTheme: {
                                            primary: "#F3B11A",
                                            secondary: "#FEFEFE",
                                        },
                                    },
                                    error: {
                                        iconTheme: {
                                            primary: "#EF4444",
                                            secondary: "#FEFEFE",
                                        },
                                    },
                                }}
                            />
                        </div>
                    </BrowserRouter>
                </CartProvider>
            </VatProvider>
        </AuthProvider>
    );
}

export default App;
